var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownAccordianArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2L7.4 8.6L6 10L12 16L18 10L16.6 8.6L12 13.2Z",
    fill: "#001133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownAccordianArrow);
export default __webpack_public_path__ + "static/media/DownAccordianArrow.7f6444f82bdfa1ad529698699c5b0b97.svg";
export { ForwardRef as ReactComponent };